export default {
    init() {
        selectOrClearAll()
    }
}

function selectOrClearAll() {
    selectAll()
    clearAll()
}

function selectAll() {
    $('#event-filter-select-all').click(function (e) {
        e.preventDefault();
        $('input[type="checkbox"]').prop('checked', true);
    });

}

function clearAll() {
    $('#event-filter-clear-all').click(function (e) {
        e.preventDefault();
        $('input[type="checkbox"]').prop('checked', false);
    });
}